import { useCallback } from 'react';
import { TableColumnFilter } from '@economic/taco';
import parseFilters from '~/app/shared/table3tools/utils/parseFilters';
import { FilterParamFactory } from '~/app/shared/table3tools/types';

export default function useDefaultFilterParamFactory(): FilterParamFactory {
    return useCallback((filters: TableColumnFilter[]) => {
        const params = parseFilters(filters);
        if (!params) {
            return '';
        }

        return `filter=${params}`;
    }, []);
}
